// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rKFH","right":"styles_right__gAqFQ"};